import * as React from 'react';

import {Body} from '../typography/body';

import styles from './list-view-special-state-text.module.css';

type Props = {
    text: string;
    cta?: React.ReactNode;
};

export function ListViewSpecialStateText(props: Props) {
    return (
        <div className={styles['list-view-special-state-text']}>
            <Body>
                {props.text}&nbsp;{props.cta}
            </Body>
        </div>
    );
}
